const fontHelpers = {
    addCustomFont: (fontSettings, isDefault) => {
        //this code was copied straight from INSIDE
        let font = fontSettings.family;

        if (!font || font == "" || !font.name || font.name == "") return;
        if (font.type == "other") {

        } else if (font.url && font.url != "") {
            var linkTag = document.createElement("link");
            linkTag.href = font.url;
            linkTag.rel = "stylesheet";
            document.head.appendChild(linkTag);
        } else if (font.files && font.files.length > 0) {
            let cssString = "@font-face {"
            cssString += "font-family: '" + font.name + "';";
            var fontsArr = [];
            for (var i = 0; i < font.files.length; i++) {
                fontsArr.push("url('" + font.files[i] + "') format('" + fontHelpers.fontFileFormat(font.files[i]) + "')");
            }
            cssString += "src: " + fontsArr.join(",");
            cssString += ";}";

            var style = document.createElement("style");
            style.appendChild(document.createTextNode(cssString));
            document.head.appendChild(style);
        }
        if (isDefault) {
            fontHelpers.addFontStyling(fontSettings);
        }

    },

    addFontStyling: (font) => {
        let str = `* { ${fontHelpers.getFontStyling(font)} }`;
        str += `button { ${fontHelpers.getFontStyling(font, true)} }`

        var style = document.createElement("style");
        style.appendChild(document.createTextNode(str));
        document.head.appendChild(style);
    },

    getFontStyling: (font, important) => {
        let str = "";
        if (!font.family) return;
        if (font.family != "" && font.family.name != "")
            str += `font-family: ${font.family.name}, 'Nunito Sans', sans-serif ${important ? "!important" : ""};`;
        if (typeof font.transform == "string" && font.transform != "")
            str += "text-transform: " + font.transform + ";";
        if (typeof font.letterSpacing != "undefined" && font.letterSpacing != "")
            str += "letter-spacing: " + font.letterSpacing + "px;";
        if (typeof font.size != "undefined" && font.size != "") {
            if (font.size.indexOf("em") != -1) {
                str += "font-size: " + font.size + ";";
            } else {
                str += "font-size: " + parseInt(font.size) + "px;";
            }
        }
        if (typeof font.weight != "undefined" && font.weight != "")
            str += "font-weight: " + font.weight + ";";

        return str;
    },

    fontFileFormat: (filename) => {
		if (filename.indexOf(".eot") != -1) {
			return 'embedded-opentype';
		} else if (filename.indexOf(".woff2") != -1) {
			return "woff2";
		} else if (filename.indexOf(".woff") != -1) {
			return "woff";
		} else if (filename.indexOf(".ttf") != -1) {
			return "truetype";
		} else if (filename.indexOf(".svg") != -1) {
			return "svg";
		} else {
			return "opentype";
		}
	},

    addCustomCss: (css) => {
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    }
}

export default fontHelpers;